import { IExperiment } from '../api/experiments';

export const AB_DEMAND_TRAP_EXPERIENCE = 'demand_trap_new_design';
export const AB_DEMAND_TRAP_GROUP = 1;

export const isABDemandTrapExperiment = (experiments: IExperiment[]): boolean => {
  const demandTrapExperiment = experiments.find(experiment => experiment.name === AB_DEMAND_TRAP_EXPERIENCE);

  const demandTrapExperimentMatched = demandTrapExperiment && demandTrapExperiment.abGroup === AB_DEMAND_TRAP_GROUP;

  return demandTrapExperimentMatched || false;
};
